import React from 'react';
import { FaFilePdf } from "react-icons/fa";
import { motion } from "framer-motion";

const iconVariants = (duration) => ({
  initial: { y: -10 },
  animate: {
    y: [10, -10],
    transition: {
      duration: duration,
      ease: "linear",
      repeat: Infinity,
      repeatType: "reverse",
    },
  },
});

const Features = () => {
  const reports = [
    {
      title: "Project Specification Report",
      file: "/322 Project Specification Report.pdf",
      iconColor: "text-red-600 dark:text-red-400",
    },
    {
      title: "Analysis Report",
      file: "/322 Project Analysis Report.pdf",
      iconColor: "text-orange-600 dark:text-orange-400",
    },
    {
      title: "High-Level Design Report",
      file: "/322 High-Level Design Report.pdf",
      iconColor: "text-amber-600 dark:text-amber-400",
    },
    {
      title: "Detailed Design Report",
      file: "/322 Detailed Design Report.pdf",
      iconColor: "text-blue-600 dark:text-blue-400",
    },
    {
      title: "Multidisiplinary Delivery Assessment",
      file: "/322 Multidisiplinary Delivery Assessment.pdf",
      iconColor: "text-green-600 dark:text-green-400",
    },
    {
      title: "Final Report",
      file: "/322 Final Report.pdf",
      iconColor: "text-purple-600 dark:text-purple-400",
    },
  ];

  return (
    <div className="border-b border-opacity-20 border-gray-400 dark:border-gray-600 pb-24 bg-surface-light dark:bg-surface-dark">
      <motion.h2
        whileInView={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: -100 }}
        transition={{ duration: 1.5 }}
        className="my-20 text-center text-4xl text-text-primary-light dark:text-text-primary-dark"
      >
        Project Reports
      </motion.h2>
      <div className="container mx-auto px-8">
        <motion.div
          whileInView={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: -100 }}
          transition={{ duration: 1.5 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-12"
        >
          {reports.map((report, index) => (
            <div key={index} className="flex flex-col items-center">
              <motion.div
                variants={iconVariants(2.5)}
                initial="initial"
                animate="animate"
                className="rounded-2xl border-2 border-gray-200 dark:border-gray-600 p-6 cursor-pointer hover:shadow-xl dark:hover:shadow-gray-800/50 transition-all"
                onClick={() => window.open(report.file, '_blank')}
                whileHover={{ scale: 1.05 }}
              >
                <FaFilePdf className={`text-7xl mx-auto ${report.iconColor}`} />
              </motion.div>
              <motion.p
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -100 }}
                transition={{ duration: 2 }}
                className="mt-6 text-lg text-center text-text-secondary-light dark:text-text-secondary-dark font-medium"
              >
                {report.title}
              </motion.p>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Features;